import { render, staticRenderFns } from "./Spiceandherbextract.vue?vue&type=template&id=1058a9c2&scoped=true&"
import script from "./Spiceandherbextract.vue?vue&type=script&lang=js&"
export * from "./Spiceandherbextract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1058a9c2",
  null
  
)

export default component.exports